export const getAncillariesForVbid = (state, isbn) => {
  const ancillariesObject = state.ancillaries.byVbid[isbn];
  return ancillariesObject ? ancillariesObject.ancillaries || [] : [];
};

export const isAncillariesFetching = (state, isbn) => {
  const ancillariesObject = state.ancillaries.byVbid[isbn];
  return ancillariesObject ? ancillariesObject.isFetching : false;
};

export const getAncillarySummaryForVbid = (state, isbn) =>
  state.ancillaries.summary[isbn] || {
    accessCodeCount: 0,
    ancillariesCount: 0
  };

export const shouldFetchAncillarySummary = state =>
  !state.ancillaries.summary.isLoaded && !state.ancillaries.summary.isFetching;

export const shouldFetchAllAccessCodes = state =>
  !state.ancillaries.accessCodes.isFetching;

export const shouldFetchAncillaries = (state, isbn) => !state.ancillaries.byVbid[isbn];

export const shouldRedeemAncillary = state => {
  return true;
};

export const getAncillarySummary = state =>
  Object.keys(state.ancillaries.summary).reduce(
    (acc, isbn) => {
      if (isbn === "isFetching" || isbn === "isLoaded") {
        return acc;
      }
      const summary = state.ancillaries.summary[isbn];
      acc.accessCodeCount += summary.accessCodeCount;
      acc.ancillariesCount += summary.ancillariesCount;
      return acc;
    },
    {
      accessCodeCount: 0,
      ancillariesCount: 0
    }
  );

export const getIsbnsWithAncillaries = state =>
  Object.keys(state.ancillaries.summary).filter(isbn => {
    if (isbn === "isFetching" || isbn === "isLoaded") {
      return false;
    }
    const summary = state.ancillaries.summary[isbn];
    return summary.ancillariesCount > 0;
  });

export const getIsbnsWithAccessCodes = state =>
  Object.keys(state.ancillaries.summary).filter(isbn => {
    if (isbn === "isFetching" || isbn === "isLoaded") {
      return false;
    }
    const summary = state.ancillaries.summary[isbn];
    return summary.accessCodeCount > 0;
  });

export const getAccessCodesForVbid = (state, isbn) => {
  const accessCode = state.ancillaries.accessCodes[isbn];
  return accessCode ? accessCode : null;
};
